<div class="fixed top-4 right-4 z-[100] flex flex-col gap-3 w-full max-w-sm">
  <div
    *ngFor="let toast of toasts"
    class="flex items-start gap-3 rounded-lg border px-4 py-3 shadow-lg bg-white"
    [ngClass]="borderClass(toast.type)">
    <lucide-icon
      [name]="icon(toast.type)"
      [size]="18"
      class="shrink-0 mt-0.5"
      [ngClass]="iconClass(toast.type)"></lucide-icon>
    <p class="flex-1 text-sm text-gray-700 leading-snug">{{ toast.message }}</p>
    <button
      type="button"
      (click)="dismiss(toast.id)"
      class="p-0.5 text-gray-400 hover:text-gray-600 transition-colors shrink-0"
      aria-label="Dismiss">
      <lucide-icon name="X" [size]="16"></lucide-icon>
    </button>
  </div>
</div>
